import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
export default function AdminRoute() {
  const { user } = useSelector(s => s.auth);
  return user?.role === 'administrateur' ? <Outlet /> : <Navigate to="/dashboard" replace />;
}
